<uni-page>
  <ng-container title>{{ 'page.404.title' | translate }}</ng-container>
  <ng-container error>{{ 'page.404.error' | translate }}</ng-container>
</uni-page>
